module.exports = __webpack_public_path__ + "static/conectionpeoplemb-862dd850a020a76bf5a6f71a502ae0d1.png";